import React from 'react';
import viewproloader from '../assets/svg/viewproloader.svg'

const Loader = props => {
  return (
    <img src={viewproloader} width="5%" height="5%" className="m-auto" alt="Loading..." />
  )
}
export default Loader